/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale, width } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { normal } from '@styles/fonts';
import AnimatedHeader, { getHeight } from '@components/common/AnimatedHeader';

const UserDetails = (props) => {
  const {
    route: {
      params: { header, backText, value },
    },
    C,
  } = props;

  return (
    <View style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <View style={{ width, height: '100%' }}>
        <AnimatedHeader
          {...{
            text: i18n.t(header),
            C,
            animated: false,
            back: true,
            backText,
            backgroundColor: 'Background/Light/Detail',
            borderBottomWidth: 0,
          }}
        />
        <View
          style={[
            {
              marginTop: getHeight() + scale(50),
              paddingHorizontal: scale(15),
            },
          ]}
        >
          <View
            style={{
              width: '100%',
              height: scale(41.5, false),
              paddingHorizontal: scale(16),
              backgroundColor: C('Background / Light / Field'),
              borderRadius: scale(10),
              justifyContent: 'center',
            }}
          >
            <Text
              numberOfLines={1}
              adjustsFontSizeToFit
              ellipsizeMode="tail"
              style={[{ color: C('Label / Light / Tertiary'), fontSize: scale(14) }, normal]}
            >
              {i18n.t(String(value) || '')}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(UserDetails);
